// NATIVE

// INSTALLED

// CUSTOM
import { useDispatch } from 'react-redux';
import { AxiosAdapter } from '../commons/adapters';
import { closeSessionGlobal } from '../commons/utils';

const http = new AxiosAdapter();

export const generateScheduleShiftsService = async (
  idGenerateShifts: string,
  setPercentage: any
) => {
  try {
    return await http.post<any>(
      '/v1/genetic-algorithm/generate-schedule-shifts',
      { id: idGenerateShifts },
      setPercentage
    );
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('generateScheduleShiftsService ', error);
  }
};
